// removed by extract-text-webpack-plugin
module.exports = {"review-average-rating":"review-average-rating_review-average-rating--6KHMmAyW","reviewAverageRating":"review-average-rating_review-average-rating--6KHMmAyW","review-average-rating__title":"review-average-rating_review-average-rating__title--3N8Hvkjw","reviewAverageRatingTitle":"review-average-rating_review-average-rating__title--3N8Hvkjw","review-average-rating__row":"review-average-rating_review-average-rating__row--3xVXpC4p","reviewAverageRatingRow":"review-average-rating_review-average-rating__row--3xVXpC4p"};


//////////////////
// WEBPACK FOOTER
// ./components/profile-right-section/src/styles/review-average-rating.scss
// module id = 2348
// module chunks = 0